import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import type { ProductItem } from "../types";

interface CardHeaderProps {
  item: ProductItem;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ item }) => {
  return (
    <div className={styles.card_header}>
      <div className={styles.card_header_main}>
        <h4 className={styles.card_name}>{item.productFamilyDesc}</h4>
        {item.materialDescription && (
          <div className={styles.card_desc}>{item.materialDescription}</div>
        )}
      </div>
      <div className={styles.card_tags}>
        <div className={styles.card_code_wrap}>
          <span className={styles.card_code_label}>Material Number</span>
          <span className={styles.card_code}>{item.materialNumberCode ?? "-"}</span>
        </div>
        <div className={styles.card_code_wrap}>
          <span className={styles.card_code_label}>HCPCS</span>
          <span className={styles.card_code}>{item.hcpcsCode ?? "-"}</span>
        </div>
      </div>
    </div>
  );
};
